import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { PasswordInput } from "@/components/PasswordInput";
import { Checkbox } from "@/components/ui/checkbox";
import { Logo } from "@/components/Logo";
import { useI18n } from "@/i18n";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Register() {
  const { t, lang } = useI18n();
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", consent_rgpd: false });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.consent_rgpd) { setError(t("form_consent")); return; }
    setError(""); setLoading(true);
    try {
      await register({ ...form, language: lang });
      navigate("/o-meu-terco");
    } catch (err) { setError(formatApiError(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center bg-th-blue th-pattern py-16 px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8">
        <div className="text-center mb-6"><Logo size={54} className="mx-auto" /><h1 className="mt-4 font-display font-bold text-2xl text-th-blue">{t("register_title")}</h1></div>
        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          <div><Label>{t("form_name")}</Label><Input required value={form.name} data-testid="register-name" onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1" /></div>
          <div><Label>{t("form_email")}</Label><Input required type="email" value={form.email} data-testid="register-email" onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1" /></div>
          <div><Label>{t("password")}</Label><PasswordInput required minLength={6} value={form.password} testid="register-password" onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1" /></div>
          <label className="flex items-start gap-3 cursor-pointer">
            <Checkbox checked={form.consent_rgpd} data-testid="register-consent" onCheckedChange={(v) => setForm({ ...form, consent_rgpd: !!v })} className="mt-0.5" />
            <span className="text-sm text-slate-600">{t("form_consent")}</span>
          </label>
          {error && <div className="text-red-600 text-sm bg-red-50 rounded p-2" data-testid="register-error">{error}</div>}
          <Button type="submit" disabled={loading} data-testid="register-submit" className="w-full bg-th-blue text-white hover:bg-th-bluelight h-11">{loading ? t("loading") : t("register_title")}</Button>
        </form>
        <p className="mt-5 text-center text-sm text-slate-500">{t("has_account")} <Link to="/entrar" className="text-th-blue font-semibold hover:text-th-gold" data-testid="link-login">{t("login_title")}</Link></p>
      </div>
    </div>
  );
}
